import Button from "components/form/Button";
import { FailedAgreementIcon } from "icons/action/FailedIcon";
import React from "react";
import { useTid } from "utils/testid";
import { customerFacingPaymentError } from "utils/HelperFunctions";

interface RetryPaymentFailesProps {
  handleBackToStart?: any;
  failedReason?: string;
}
const RetryPaymentFailed = (props: RetryPaymentFailesProps) => {
  const tid = useTid();
  const { handleBackToStart, failedReason } = props;

  return (
    <div
      className="h-full flex items-center justify-center lg:px-0 px-5 lg:pb-0 pb-10"
      data-testid={tid("retry-payment-failed")}
      aria-label="Payment failed"
    >
      <div
        className={`w-full  flex flex-col justify-center items-center gap-6`}
      >
        <div className="w-full flex flex-col justify-center items-center gap-10">
          <FailedAgreementIcon aria-hidden="true" />
          <div className="w-full text-center text-xl text-txtPrimary font-medium">
            Payment failed
          </div>
          <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-lg text-base text-txtParagraph break-words">
            {customerFacingPaymentError(failedReason) || "Payment Failed"}
          </div>
          <div className="w-full text-center text-txtParagraph lg:text-xl">
            Sorry! Your payment method was declined.
          </div>
          <div>
            <Button
              text={"Update payment method"}
              data-testid={tid("retry-payment-update-method-button")}
              aria-label="Update payment method"
              className="text-base px-11"
              onClick={() => handleBackToStart()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetryPaymentFailed;
